import { useQuery } from '@tanstack/react-query'

import chatService from '../services'
import { chatKeys } from '../../keys'

export interface SearchMessagesParams {
	query?: string
	roomId?: string
	direction?: 'INCOMING' | 'OUTGOING'
	dateFrom?: string
	dateTo?: string
	limit?: number
}

export function useQuerySearchMessages(
	params: SearchMessagesParams,
	enabled = true,
) {
	return useQuery({
		queryKey: chatKeys.searchMessages(params),
		queryFn: () => chatService.searchMessages(params),
		enabled: enabled && !!params.query,
	})
}
